// pages/PurelloFormPage/PurelloFormPage.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import Nav from "../../components/Nav/Nav";
import HeroSection from "../../components/HeroSection/HeroSection";
import Footer from "../../components/Footer/Footer";
import GoogleFormEmbed from "../../components/GoogleFormEmbed/GoogleFormEmbed";
import Purello2 from "../../assets/images/purello/Purello2.webp";
import styles from "./PurelloFormPage.module.css";

const PurelloFormPage: React.FC = () => {
  const { t } = useTranslation();
  const googleFormUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSfnD7f9MRE-HE5I0WMCaMMgsvlSWl90wnZ87wmDqyTmTjm_cg/viewform?embedded=true"; // Replace with actual Google Form embed URL

  return (
    <>
      <Nav />
      <HeroSection
        title={t("purello_form_page.title")}
        subtitle={t("purello_form_page.subtitle")}
        backgroundImage={Purello2}
      />
      <div className={styles.purelloFormSection}>
        <GoogleFormEmbed formUrl={googleFormUrl} />
      </div>
      <Footer />
    </>
  );
};

export default PurelloFormPage;
